import { makeStyles } from '@material-ui/core/styles';
import { COLORS, SPACING } from '../constants';

export const useStyles = makeStyles(() => ({
  root: {
    flex: 1,
    display: 'flex',
    overflow: 'hidden',
  },
  sidebar: {
    width: 260,
    maxHeight: '100vh',
    background: COLORS.white,
    borderRight: `1px solid ${COLORS.border}`,
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    overflow: 'hidden',
  },
  sidebarHeader: {
    padding: 12,
    borderBottom: `1px solid ${COLORS.border}`,
    flexShrink: 0,
  },
  sidebarTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: COLORS.body,
    marginBottom: 6,
  },
  searchWrapper: {
    position: 'relative',
  },
  searchIcon: {
    position: 'absolute',
    left: 7,
    top: 7,
    fontSize: 12,
    color: COLORS.muted,
  },
  treeContainer: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
    padding: 12,
  },
  mainContent: {
    flex: 1,
    overflow: 'auto',
    padding: SPACING.sectionGap,
  },
  breadcrumbs: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginBottom: 8,
    fontSize: 11,
    color: COLORS.muted,
  },
  breadcrumbButton: {
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    fontSize: 'inherit',
  },
  breadcrumbActive: {
    color: COLORS.primary,
    fontWeight: 600,
  },
  breadcrumbInactive: {
    color: COLORS.muted,
    fontWeight: 400,
  },
  locationHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  locationActions: {
    display: 'flex',
    gap: 6,
  },
  emptyState: {
    padding: 20,
    textAlign: 'center',
    color: COLORS.muted,
    fontSize: 13,
    background: COLORS.white,
    borderRadius: 6,
    border: `1px dashed ${COLORS.border}`,
  },
  statusMessage: {
    marginBottom: 12,
    fontSize: 13,
  },
}));
